import { dom } from 'react-redux-app/lib/modules/core/utils';
import { getCurrentLang } from 'react-redux-app/lib/modules/i18n/selectors';
import { getIndexUrl } from '../../utils/siteUrls';
import { actionAddGlobalError } from 'react-redux-app/lib/modules/globalError/actions';
import {
  SOCIAL_NETWORK_ALREADY_ASSIGNED_SUCH_TYPE,
  SOCIAL_NETWORK_ALREADY_ASSIGNED_TO_ANOTHER_USER,
  SOCIAL_NETWORK_ALREADY_ASSIGNED_TO_USER,
  SOCIAL_NETWORK_SHOULD_ASSIGN_AFTER_LOGIN,
  SOCIAL_NETWORK_AUTH_FAILED,
} from '../../../socialNetworksSettings/constants/errors';


const socialNetworkHandler = (
  { getState, dispatch },
  nextState,
  successCallback,
  errorCallback,
  commandParams
) => {
  const socialNetworkAuthError = JSON.parse(commandParams.error);

  const addGlobalError = textLangKey => {
    dispatch(actionAddGlobalError({
      text: { id: textLangKey },
      header: { id: 'header.social.settings' },
    }));
  };

  switch (socialNetworkAuthError.code) {
    case SOCIAL_NETWORK_AUTH_FAILED:
      dom.redirect(getIndexUrl(getCurrentLang(getState())));
      break;

    case SOCIAL_NETWORK_ALREADY_ASSIGNED_SUCH_TYPE:
      addGlobalError('error.social.already-assigned-such-type');
      break;

    case SOCIAL_NETWORK_ALREADY_ASSIGNED_TO_USER:
      addGlobalError('error.social.already-assigned-to-user');
      break;

    case SOCIAL_NETWORK_ALREADY_ASSIGNED_TO_ANOTHER_USER:
      addGlobalError('error.social.assigned-to-another-user');
      break;

    case SOCIAL_NETWORK_SHOULD_ASSIGN_AFTER_LOGIN:
      addGlobalError('error.social.duplicate-email');
      break;

    default:
      break;
  }

  successCallback();
};

export const handler = socialNetworkHandler;
export const params = ['error'];
